// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manual-title {
  margin-bottom: 20px;
  font-size: 20px;
  color: #434C63;
  text-align: center;
}

.manual-block {
  font-size: 14px;
}

.manual-block:after {
  margin: 10px 0;
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background-color: #B8B8B8;
}

.manual-section{
  font-size: 17px;
  font-weight: 600;
  color: #434C63;
}`, "",{"version":3,"sources":["webpack://./src/pages/Manual/style.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".manual-title {\n  margin-bottom: 20px;\n  font-size: 20px;\n  color: #434C63;\n  text-align: center;\n}\n\n.manual-block {\n  font-size: 14px;\n}\n\n.manual-block:after {\n  margin: 10px 0;\n  content: '';\n  display: block;\n  width: 100%;\n  height: 1px;\n  background-color: #B8B8B8;\n}\n\n.manual-section{\n  font-size: 17px;\n  font-weight: 600;\n  color: #434C63;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
